// ##################################################### //
// #               AUTO GENERATED FILE                 # //
// # Run `npm run icon` to update this file            # //
// #                                                   # //
// # Any changes made after this time will be          # //
// # overwritten the next time the script is executed. # //
// ##################################################### //

/**
 * Hash for cache busting
 */
export const KYC_APP_ICON_HASH = '302e3f75d8f41457d81fd52d873ba5c1';

/**
 * Enum for all available icons
 */
export enum KYC_APP_ICON {
  CAMERA_C = 'camera-C',
  DRIVERS_LICENSE = 'drivers-license',
  FILTER_2_L = 'filter-2-L',
  ID_CARD = 'id-card',
  ID_SCAN_C = 'id-scan-C',
  INDICATOR_NO = 'indicator-no',
  INDICATOR_YES = 'indicator-yes',
  MAIL = 'mail',
  PASSPORT = 'passport',
  PERSON_GROUP = 'person-group',
  RESIDENCE_TITLE = 'residence-title',
  RESIDENCE_PERMIT = 'residence-title',
  SIGN_OUT = 'sign-out',
}
